"use strict";

var waitToShrink = require('./waitToShrink');

var mountingNote = require('./mountingNote');

var addCornerRounding = require('./addCornerRounding');

var adhesiveMachine = require('./adhesiveMachine');

var customNote = require('./customNote');

var setPaperSize = require('./setPaperSize');

var ivoryMatteNote = require('./ivoryMatteNote');

var holePunch = require('./holePunch');

var duplex = require('./duplex');

module.exports = {
  waitToShrink: waitToShrink,
  duplex: duplex,
  addCornerRounding: addCornerRounding,
  adhesiveMachine: adhesiveMachine,
  customNote: customNote,
  setPaperSize: setPaperSize,
  ivoryMatteNote: ivoryMatteNote,
  holePunch: holePunch,
  mountingNote: mountingNote
};